export const START = 'START';
export const QUOTING = 'QUOTING';
export const QUOTED = 'QUOTED';
export const PRICE_SELECTED = 'PRICE_SELECTED';
export const ERROR = 'ERROR';
export const CAN_NOT_QUOTE_AUTOMATICALLY = 'CAN_NOT_QUOTE_AUTOMATICALLY';
